import { UK_LOCATIONS } from './locations/UK';
import { USA_LOCATIONS } from './locations/USA';
import { EventData } from '../types/firebase';
import { ProviderData } from '../types/firebase';

export const LOCATIONS = {
    ...UK_LOCATIONS,
    ...USA_LOCATIONS
} as const;

export const COUNTRIES = ['UK', 'USA'] as const;

export const getRegionsByCountry = (countryName: string): string[] => {
    return Object.values(LOCATIONS)
        .filter(location  => location.country === countryName)
        .map(location => location.region);
};

export const getEventsByRegion = (regionName: string | null, events: any[]) => {
    // returns all events if cityName is null, otherwise returns events that match the cityName 
    // in the provider_region or event_region or event_country_city
    if (regionName === null) return events;
    return events.filter(event => event.providerDetails.provider_region === regionName || event.event_region === regionName );
};

export const getEventsByCountry = (countryName: string | null, events: any[]) => {
    // returns event if event_country or provider_country is the countryName
    if (countryName === null) return events;
    return events.filter(event => event.providerDetails.provider_country === countryName || event.event_country === countryName);
};  

// used to format the location on the single event page
// formats to  this style:
// Central Park, New York, NY 10022
// United States
export const formatLocation = (event: EventData) => {
    // Build the first line: venue, region/city, postcode
    const firstLineParts = [
        event.venue,
        event.address,
        event.event_region || event.providerDetails?.provider_region,
        event.event_postcode || event.providerDetails?.provider_postcode
    ].filter(Boolean); // Remove empty/null/undefined values

    // Build the second line: country
    const country = event.event_country || event.providerDetails?.provider_country;

    // Join the parts with appropriate separators
    const firstLine = firstLineParts.join(', ');
    
    // Return formatted address
    // If we have both lines, join them with a newline
    // If we only have one or the other, return what we have
    return [firstLine, country].filter(Boolean).join('\n');
};

export const getPractitionersByRegion = (regionName: string | null, practitioners: ProviderData[]) => {
    if (regionName === null) return practitioners;
    return practitioners.filter(practitioner => practitioner.provider_region === regionName);
};

export const getPractitionersByCountry = (countryName: string | null, practitioners: ProviderData[]) => {
    if (countryName === null) return practitioners;
    return practitioners.filter(practitioner => practitioner.provider_country === countryName);
};